<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1">
    <div class="absolute insights-bg z-index--1 md:block lg:block hidden">
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="absolute insights-bg-mob md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="">
      <div
        class="
          md:w-4/5
          lg:w-4/5
          w-full
          md:px-0
          lg:px-0
          px-4
          mx-auto
          md:pt-32
          lg:pt-32
          pt-6
        "
      >
        <div class="flex justify-between items-center">
          <p
            class="
              title
              fsize36-16px-isg
              lg:font-normal
              md:font-normal
              font-bold
            "
          >
            Latest Prsentation
          </p>
          <div class="md:block lg:block hidden">
            <div class="flex text-black">
              <b-form-select
                v-model="selectedDis"
                :options="Disease"
                class="
                  mr-4
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
              <b-form-select
                v-model="selectedSeg"
                :options="Segment"
                class="
                  mr-4
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
              <b-form-select
                v-model="selectedUsers"
                :options="Users"
                class="
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
            </div>
          </div>
        </div>
        <div class="md:pt-10 lg:pt-10 pt-0">
          <div
            class="
              grid
              md:grid-cols-4
              lg:grid-cols-4
              grid-cols-1 grid-rows-2
              gap-x-8
              md:gap-y-16
              lg:gap-y-16
            "
          >
            <div
              class="md:mt-0 lg:mt-0 mt-6"
              v-for="(item, index) in news"
              :key="'item -' + index"
            >
              <img
                :src="item.image"
                alt="NewsTitle"
                class="rounded-lg h-52 w-full object-cover"
              />
              <p
                class="
                  md:mt-5
                  lg:mt-5
                  mt-2
                  text-black
                  footertitle
                  font-bold
                  cursor-pointer
                  fsize24-14px
                "
                @click="handleClick('news')"
              >
                News Title Lorem Ipsum Dolor Sit Amet
              </p>
              <div class="md:mt-5 lg:mt-5 mt-2 flex">
                <p class="text-xs clr777 font-normal">1 Hour ago</p>
                <p class="text-xs clr777 font-normal ml-6">200 views</p>
              </div>
            </div>
          </div>
        </div>
        <div class="md:mt-20 lg:mt-20 mt-8 flex">
          <base-button
            outline
            type="primary"
            class="
              md:px-10
              lg:px-10
              px-6
              md:py-3
              lg:py-3
              py-1
              fs16700
              border-2
              mx-auto
            "
            >View more</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedDis: null,
      selectedUsers: null,
      selectedSeg: null,
      Disease: [
        { value: null, text: "Disease" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: "c", text: "This one is disabled" },
      ],
      Segment: [
        { value: null, text: "Segment" },
        { value: "d", text: "This is First option" },
        { value: "e", text: "Selected Option" },
        { value: "f", text: "This one is disabled" },
      ],
      Users: [
        { value: null, text: "Users" },
        { value: "g", text: "This is First option" },
        { value: "h", text: "Selected Option" },
        { value: "i", text: "This one is disabled" },
      ],
      news: [
        {
          image: require("@/assets/images/child cancer.jpg"),
        },
        {
          image: require("@/assets/images/news2.jpg"),
        },
        {
          image: require("@/assets/images/news3.jpg"),
        },
        {
          image: require("@/assets/images/news4.jpg"),
        },
        {
          image: require("@/assets/images/news5.jpg"),
        },
        {
          image: require("@/assets/images/abtus.jpg"),
        },
        {
          image: require("@/assets/images/hcp-grid2.jpg"),
        },
        {
          image: require("@/assets/images/img8.jpg"),
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
  },
};
</script>
